module.exports = __webpack_public_path__ + "static/media/12_tn.eade135d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/12_tn.jpg
// module id = 648
// module chunks = 0